import type { FC } from 'react';
import { PiHouseLight } from 'react-icons/pi';
import type { ConversationPropertyPhotoPlaceholderProps } from '../../types/conversation-property-summary.type';

/** Renders the accessible fallback for an absent property photo. */
export const ConversationPropertyPhotoPlaceholder: FC<
  ConversationPropertyPhotoPlaceholderProps
> = ({ label }) => (
  <div
    className="h-full w-full flex-none object-cover flex items-center justify-center overflow-hidden rounded-lg bg-neutral-100 text-secondary-500"
    role="img"
    aria-label={label}
  >
    <PiHouseLight className="h-6 w-6" aria-hidden="true" />
  </div>
);
